import { useEffect } from "react";

const setMeta = (name, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setOg = (property, content) => {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const usePageMeta = ({ title, description, path }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("description", description);
    setMeta("robots", "index,follow");
    setOg("og:title", title);
    setOg("og:description", description);
    setOg("og:type", "website");
    setOg("og:locale", "nl_BE");
    if (path) setOg("og:url", `https://dilagroupservices.be${path}`);
  }, [title, description, path]);
};
